import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import '../css/pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevPage = () => {
    onPageChange(currentPage - 1);
  };

  const handleNextPage = () => {
    onPageChange(currentPage + 1);
  };

  const handlePageClick = (page) => {
    onPageChange(page);
  };

  // Generate an array of page numbers
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="pagination-container">
      <button className="pagination-button" disabled={currentPage === 1} onClick={handlePrevPage}>
      <FontAwesomeIcon icon={faAngleDown} className="previous" />
      </button>
      {pageNumbers.map(page => (
          <button
          key={page}
          className={`pagination-button ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
          >
          {page}
        </button>
      ))}
      <button className="pagination-button" disabled={currentPage === totalPages} onClick={handleNextPage}>
      <FontAwesomeIcon icon={faAngleDown} className="next" />
        
      </button>
    </div>
  );
};

export default Pagination;